import { App, InjectionKey } from "vue";
import ApiController from "../controllers/ApiController";
export const ApiInjectionKey: InjectionKey<ApiController> = Symbol();
export default {
  install: (app: App, options: any) => {
    const api = new ApiController();
    app.provide(ApiInjectionKey, api);
  },
};
